import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ListSharedComponent } from './list.component';

import { IconSharedModule } from './../icon/icon.module';

@NgModule({
    declarations: [
        ListSharedComponent
    ],
    imports: [
        CommonModule,
        IconSharedModule
    ],
    exports: [
        ListSharedComponent
    ]
})

export class ListSharedModule {}
